export default {
    and: () =>
        JIX.Gettext.__("og"),
    countOthers: (n) =>
        JIX.Gettext.__nx("{n} anden", "{n} andre", n, { n }),
};
